import type { TMessageSender } from '@/modules/Socket';

import { DEFAULT_OPERATOR_LABEL } from '@/constants/common';

export type TBubbleHeaderNameParams = {
  label?: string;
  senderName: string;
};

export type TBubbleHeaderConfig = {
  getName: (params: TBubbleHeaderNameParams) => string;
  badge?: string;
};

export const BUBBLE_HEADER_CONFIG: Partial<Record<TMessageSender, TBubbleHeaderConfig>> = {
  AI: { getName: ({ senderName }) => senderName, badge: 'AI' },
  OPERATOR: { getName: ({ label }) => label ?? DEFAULT_OPERATOR_LABEL },
};

export const hasBubbleHeader = (sender?: TMessageSender): boolean => Boolean(sender && BUBBLE_HEADER_CONFIG[sender]);
